module.exports = __webpack_public_path__ + "assets/gold-trigger.47e05c7b.svg";